module.exports = __webpack_public_path__ + "media/images/common/menu_regist_coop-f8804b5e316e8f3e954d3e8a4c972aa5.png";